import { render, staticRenderFns } from "./DiamondDoraAnimation.vue?vue&type=template&id=f51e6a50&"
import script from "./DiamondDoraAnimation.vue?vue&type=script&lang=js&"
export * from "./DiamondDoraAnimation.vue?vue&type=script&lang=js&"
import style0 from "./DiamondDoraAnimation.vue?vue&type=style&index=0&id=f51e6a50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports